import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { exportTableToPDF } from "../utils/exportPDF";

const PurchaseStock = () => {
  const [stockList, setStockList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user_id, setUserId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterRange, setFilterRange] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const itemsPerPage = 10;

  const safeNum = (val) =>
    val === null || val === undefined || val === "" ? 0 : Number(val);

  useEffect(() => {
    const storedUserId = localStorage.getItem("user_id");
    if (storedUserId) {
      setUserId(storedUserId);
    }
  }, []);

  const fetchStock = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://ims-backend.indevconsultancy.in/admin-panel/main-stock/?user_id=${user_id}`
      );
      setStockList(res.data || []);
    } catch (err) {
      console.error("Error fetching stock list:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user_id) {
      fetchStock();
    }
  }, [user_id]);

  const filteredStockList = stockList
    .filter((item) =>
      item.stock_name.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .filter((item) => {
      const quantity = safeNum(item.quantity);
      const min = safeNum(item.min);
      const max = safeNum(item.max);

      if (!filterRange) return true;
      if (filterRange === "below") return quantity < min;
      if (filterRange === "between") return quantity >= min && quantity <= max;
      if (filterRange === "above") return quantity > max;
      return true;
    });

  const totalPages = Math.ceil(filteredStockList.length / itemsPerPage);
  const paginatedStockList = filteredStockList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filterRange]);

  const getStatusBadge = (status) => {
    if (status === 1 || status === "1") {
      return (
        <span className="badge bg-success">
          <i className="fas fa-check-circle me-1"></i> Received
        </span>
      );
    } else if (status === 0 || status === "0") {
      return (
        <span className="badge bg-warning">
          <i className="fas fa-hourglass-half me-1"></i> Approved
        </span>
      );
    } else {
      return (
        <span className="badge bg-success">
          <i className="fas fa-question-circle me-1"></i> Received
        </span>
      );
    }
  };

  const openEditModal = (item) => {
    setEditItem(item);
    setShowModal(true);
  };

  const closeEditModal = () => {
    setEditItem(null);
    setShowModal(false);
  };


  const handleUpdate = async (updated) => {
    try {
      await axios.put(
        `https://ims-backend.indevconsultancy.in/admin-panel/main-stock/${updated.id}/`,
        updated   // ✅ abhi sahi object jaayega
      );
      closeEditModal();
      fetchStock();
    } catch (error) {
      console.error("Update failed", error);
      alert("Update failed");
    }
  };


  const EditModal = ({ show, item, onClose, onSave }) => {
    const [formData, setFormData] = useState({
      stock_name: item?.stock_name || "",
      quantity: item?.quantity || 0,
      min: item?.min || 0,
      max: item?.max || 0,
    });

    useEffect(() => {
      if (item) {
        setFormData({
          stock_name: item.stock_name,
          quantity: item.quantity,
          min: item.min ?? 0,
          max: item.max ?? 0,
        });
      }
    }, [item]);

    if (!show || !item) return null;

    return (
      <div className="modal d-block" tabIndex="-1" style={{ background: "#00000099" }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Stock Item</h5>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              {/* Item Name (Read Only) */}
              <div className="mb-3">
                <label>Item Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.stock_name}
                  readOnly
                />
              </div>

              {/* Quantity (Read Only) */}
              <div className="mb-3">
                <label>Quantity</label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}

                  className="form-control"
                  value={formData.quantity}
                  onChange={(e) =>
                    setFormData({ ...formData, quantity: e.target.value })
                  }
                // readOnly
                />
              </div>

              {/* Min (Editable) */}
              <div className="mb-3">
                <label>Min</label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}

                  className="form-control text-danger"
                  value={formData.min}
                  onChange={(e) =>
                    setFormData({ ...formData, min: e.target.value })
                  }
                />
              </div>

              {/* Max (Editable) */}
              <div className="mb-3">
                <label>Max</label>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}

                  className="form-control text-success"
                  value={formData.max}
                  onChange={(e) =>
                    setFormData({ ...formData, max: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button
                className="btn btn-primary"
                onClick={() => onSave({ ...item, ...formData })}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const exportToCSV = () => {
    if (stockList.length === 0) return;

    const headers = [
      "S.No.",
      "Item",
      "Quantity",
      "Max Quantity",
      "Min Quantity",
    ];
    const rows = stockList.map((user, index) => [
      index + 1,
      `${user.stock_name}`,
      user.quantity,
      user.max_range,
      user.min_range,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "stock_list.csv");
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link); // Clean up
  };

  const exportToPDF = () => {
    if (stockList.length === 0) return alert("No data to export.");
    const headers = ["S.No.", "Item", "Quantity", "Max Quantity", "Min Quantity"];
    const rows = stockList.map((user, index) => [index + 1, user.stock_name, user.quantity, user.max_range, user.min_range]);
    exportTableToPDF({ title: "Purchase Stock Report", headers, rows, filename: "stock_list.pdf", filterInfo: `Total: ${rows.length}` });
  };

  return (
    <div className="container-fluid px-2">
      <div className="row align-items-center justify-content-between py-2">
        <div className="col-md-6 col-6">
          <span className="fs-1">Stock List Purchase</span>
        </div>
        <div className="col-md-6 col-6 text-end">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb bg-light p-2 rounded d-inline-flex mb-0">
              <li className="breadcrumb-item active" aria-current="page">
                Stock List Purchase
              </li>
              <li className="breadcrumb-item">
                <Link to="/purchaseDashboard">Home</Link>
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <div className="card">
        <div className="card-header border-info">
          <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div className="row g-3">
              <div className="col-lg">
                <input
                  type="text"
                  placeholder="Items Name"
                  className="form-control"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="col-lg-2">
                <button type="submit" className="btn btn-primary w-100">
                  Search
                </button>
              </div>
              <div className="col-lg-1">
                <button
                  type="button"
                  className="btn btn-outline-dark w-100"
                  onClick={() => setSearchTerm("")}
                >
                  Reset
                </button>
              </div>
            </div>
          </form>

          <div className="row mt-3">
            <div className="col-md-8 d-flex flex-wrap gap-2 mt-2 mt-md-0">
              <button
                className="btn btn-sm"
                style={{ color: "red" }}
                onClick={() => setFilterRange("below")}
              >
                ● Below Min
              </button>
              <button
                className="btn btn-sm"
                style={{ color: "orange" }}
                onClick={() => setFilterRange("between")}
              >
                ● Between Min & Max
              </button>
              <button
                className="btn btn-sm"
                style={{ color: "green" }}
                onClick={() => setFilterRange("above")}
              >
                ● Above Max
              </button>
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={() => setFilterRange(null)}
              >
                Clear Filter
              </button>


            </div>

            <div className="text-end">
              <button className="btn btn-primary btn-sm me-1" onClick={exportToCSV}>
                <i className="fas fa-file-csv me-1"></i>Export CSV
              </button>
              <button className="btn btn-danger btn-sm" onClick={exportToPDF}>
                <i className="fas fa-file-pdf me-1"></i>Export PDF
              </button>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive scrollbar">
            <table className="table text-center table-bordered table-striped fs--1 mb-0">
              <thead className="bg-primary text-white">
                <tr>
                  <th>S.No</th>
                  <th>Items Name</th>
                  <th>Item Code</th>
                  <th>Quantity</th>
                  <th>Unit (price)</th>
                  <th>Min</th>
                  <th>Max</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={7}>Loading...</td>
                  </tr>
                ) : paginatedStockList.length === 0 ? (
                  <tr>
                    <td colSpan={7}>No records found</td>
                  </tr>
                ) : (
                  paginatedStockList.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.stock_name}</td>
                      <td>000-{item.items_id}</td>

                      {/* Quantity me color apply */}
                      <td
                        className={
                          safeNum(item.quantity) < safeNum(item.min)
                            ? "text-danger fw-bold"
                            : safeNum(item.quantity) > safeNum(item.max)
                              ? "text-success fw-bold"
                              : "text-warning fw-bold"
                        }
                      >
                        {safeNum(item.quantity)}
                      </td>

                      <td>{item.unit}</td>
                      <td>{item.min ?? "-"}</td>
                      <td>{item.max ?? "-"}</td>
                      <td>{getStatusBadge(item.status)}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => openEditModal(item)}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>

            </table>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary btn-sm"
              disabled={currentPage === 1}
              onClick={handlePrevPage}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages || 1}
            </span>
            <button
              className="btn btn-outline-primary btn-sm"
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={handleNextPage}
            >
              Next
            </button>
          </div>
        </div>
      </div>

      {/* Edit Modal */}
      <EditModal
        show={showModal}
        item={editItem}
        onClose={closeEditModal}
        onSave={handleUpdate}
      />
    </div>
  );
};

export default PurchaseStock;
